import useFetch from "service/connect";

export const UseControlMedico = () => {
  const { call } = useFetch();

  const cargaInicial = () => {
    return call({
      url: "tablasGenerales",
      config: {
        method: "POST",
      },
    });
  };

  const listar = (data: {}) => {
    return call({
      url: "control/listar",
      config: {
        method: "POST",
        data,
      },
    });
  };

  const anular = (data: {}) => {
    return call({
      url: "programaciones",
      config: {
        method: "DELETE",
        data,
      },
    });
  };

  const registrarAsistencia = (data: {}) => {
    return call({
      url: "asistencia",
      config: {
        method: "POST",
        data,
      },
    });
  };

  const listarDetalleEmo = (data: {}) => {
    return call({
      url: "detalleEmo",
      config: {
        method: "POST",
        data,
      },
    });
  };

  const registrarEmoMasivo = (data: {}) => {
    return call({
      url: "registrarEmoMasivo",
      config: {
        method: "POST",
        data,
      },
    });
  };

  const registrarEmoCertificado = (data: {}) => {
    return call({
      url: "registrarEmoCertificado",
      config: {
        method: "POST",
        data,
      },
    });
  };

  const exportar = (data: {}) => {
    return call({
      url: "exportarControlMedico",
      config: {
        method: "POST",
        data,
      },
    });
  };

  const downloadFile = (id: number) => {
    return call(
      {
        url: `downloadFile/${id}`,
        config: {
          method: "GET",
          responseType: "blob",
        },
      },
      false
    );
  };

  return {
    cargaInicial,
    listar,
    anular,
    listarDetalleEmo,
    registrarEmoMasivo,
    registrarEmoCertificado,
    downloadFile,
    registrarAsistencia,
    exportar,
  };
};
